const BoldText = ({ text }: { text: string }) => {
  return <span style={{ fontWeight: 'bold' }}>{text}</span>;
};

export default BoldText;
